



































































































import { State, Action, Getter } from 'vuex-class';
import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import { ProfileState, User } from '../store/profile/types';
import axios from 'axios';
import store from '../store';
const namespace: string = 'Terms';

@Component
export default class Terms extends Vue {

}
